import {StringHelper} from "../../../helpers/stringHelper";
import {IDynamicDataConfig} from "../../../interfaces/dynamicFieldsInterfaces";
import {InstanceHelper} from "~/helpers/instanceHelper";
import dropdownControlMixin from '~/components/dynamicFieldsTrees/mixins/dropdownControlMixin'
import DynamicInput from '~/models/dynamicInput'
import {CertificateDynamicInputType} from "../../../../formability/certificateBuilder/enums/certificateDynamicInputType";
import {ModelType, ModelTypeIcon} from "~/enums/modelType";
import CollapsibleSection from "~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue";
import FieldItem from "~/components/dynamicFieldsTrees/handlerComponents/common/field-item.vue";

export default {
  mixins: [
    dropdownControlMixin
  ],
  components: {
    CollapsibleSection,
    FieldItem,
  },
  props: {
    q: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default: 'select'
    },
  },
  data: function (): object {
    return {
      hasSearched: false,
    };
  },
  computed: {
    lowerQ(): string {
      return StringHelper.escape(this.q.toLowerCase());
    },
  },
  methods: {
    isPresent(item: Array<any> | boolean): boolean {
      return InstanceHelper.isPresent(item);
    },
    isOpen(item: Array<any> | boolean = null): boolean {
      if (!this.hasSearched) {
        return false;
      }
      return InstanceHelper.isPresent(item);
    },
    modeIs(mode: string) {
      return this.mode === mode;
    },
    select(config: IDynamicDataConfig): void {
      this.$emit('select', config);
    },
    modelTypeIcon(modelType: ModelType): string {
      return ModelTypeIcon[modelType];
    }
  },
}